import { useQuery } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { fetchMe } from '@/lib/authApi'
import type { UserResponse } from '@/types/auth'

export const meQueryKey = ['me'] as const

export function useMe() {
  return useQuery<UserResponse, AxiosError>({
    queryKey: meQueryKey,
    queryFn: fetchMe,
    staleTime: 5 * 60 * 1000,
    retry: (failureCount, error) => {
      if (error.response?.status === 401) return false
      return failureCount < 2
    },
  })
}
